<template>
  <div class="container">
    <HeaderView />
    <div :class="{
        'bg-content': $store.state.screenWidth > 375,
        'bg-content-se': $store.state.screenWidth <= 375,
        'bg-content-4': $store.state.screenWidth <= 320,
      }">
      <div class="container">
        <div class="row">
          <div class="col-sm-4"></div>
          <div class="col-sm-4">
            <h2
              class="mt-3"
              style="font-family: 'Mitr', sans-serif; font-size: 30px;"
            >
              <img src="/static/img/icons/apple-touch-icon-60x60.png" />
              &nbsp;ลงทะเบียน
            </h2>
            <form
              id="formprofile"
              class="needs-validation"
              novalidate
              autocomplete="off"
            >
              <label class="mb-2">รหัสบัตรประชาชนหรือเลขพาสปอร์ต/Citizen&Passportid</label>
              <input
                class="form-control mb-2"
                style="font-family: 'Mitr', sans-serif;"
                type="text"
                v-model="citizen_id"
                autocomplete="off"
                required
                readonly
              />
              <label class="mb-2">ชื่อ - นามสกุล/Fullname</label>
              <input
                class="form-control mb-2"
                style="font-family: 'Mitr', sans-serif;"
                type="text"
                v-model="fullname"
                autocomplete="off"
                required
              />
              <label class="mb-2">เบอร์โทรศัพท์/Telephone</label>
              <input
                class="form-control mb-2"
                style="font-family: 'Mitr', sans-serif;"
                type="text"
                v-model="tel"
                v-mask="'###-###-####'"
                autocomplete="off"
                required
              />
              <label class="mb-2">อีเมล/Email</label>
              <input
                class="form-control mb-2"
                style="font-family: 'Mitr', sans-serif;"
                type="email"
                v-model="email"
                autocomplete="off"
                required
              />
              <label class="mb-2">สถานศึกษาปัจจุบัน/School</label>
              <vue-bootstrap-typeahead
                class="mb-2"
                style="font-family: 'Mitr', sans-serif;"
                inputClass="form-control"
                v-model="school"
                :data="school_lists"
              />
              <!-- <input
                class="form-control mb-2"
                style="font-family: 'Mitr', sans-serif;"
                type="text"
                v-model="school"
                autocomplete="off"
                required
              /> -->
              <label class="mb-2">คณะที่สนใจ/faculty</label>
              <select
                class="form-select mb-2"
                v-model="facId"
                style="font-family: 'Mitr', sans-serif;"
              >
                <option :value="0">
                  ไม่ทราบ/ยังไม่ตัดสินใจ
                </option>
                <option
                  v-for="(cp, i) in fac_list"
                  :key="'rcf' + i"
                  :value="cp.id"
                >
                  {{ cp.name }}
                </option>
              </select>
              <label class="mb-2">หลักสูตรที่สนใจ/major</label>
              <textarea
                class="form-control mb-2"
                rows="2"
                style="font-family: 'Mitr', sans-serif;"
                type="text"
                v-model="depName"
                autocomplete="off"
              />
            </form>
            <div class="d-flex justify-content-between align-items-center pb-5">
              <button
                class="btn bg-rmutl text-white"
                style="
                  width: 48%;
                  font-size: 22px;
                  font-family: 'Mitr', sans-serif;
                "
                @click="validateForm"
              >
                <i class="ti ti-device-floppy"></i>
                &nbsp;บันทึก
              </button>
              <button
                class="btn bg-ligth"
                style="
                  width: 48%;
                  font-size: 22px;
                  font-family: 'Mitr', sans-serif;
                "
                @click="$router.push('/')"
              >
                <i class="ti ti-chevron-left"></i>
                &nbsp;ย้อนกลับ
              </button>
            </div>
          </div>
          <div class="col-sm-4"></div>
        </div>
      </div>
      <div style="height: 100px;" />
    </div>
    <!-- model consent -->
    <button
      type="button"
      id="consentRule"
      data-bs-toggle="modal"
      data-bs-target="#consentModal"
      style="display: none;"
    ></button>

    <!-- Modal -->
    <div
      class="modal fade"
      id="consentModal"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="consentModalLabel"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-body">
            <h2 class="text-center">เงื่อนไขและข้อตกลงในการใช้บริการ</h2>
            <div class="text-left">
              &emsp;&emsp;มหาวิทยาลัยเทคโนโลยีราชมงคลล้านนา (ต่อไปนี้จะแทนด้วย
              “มทร.ล้านนา”) ได้ตระหนักถึงความสำคัญในการคุ้มครองข้อมูลส่วนบุคคล
              (Personal Data Protection Policy) ขึ้น
              โดยนโยบายดังกล่าวจะหมายรวมไปถึงการปฏิบัติต่อข้อมูลส่วนบุคคลของผู้ใช้
              เช่น การจัดเก็บข้อมูล การเก็บรักษา การประมวลผล การเปิดเผย
              สิทธิการเข้าถึงข้อมูล รวมถึงสิทธิต่าง ๆ ของแต่ละผู้ใช้เป็นต้น
              เพื่อให้เจ้าของข้อมูลได้ทราบถึงนโยบายในการคุ้มครองข้อมูลส่วนบุคคล
              มทร.ล้านนา จึงขอประกาศเงื่อนไขและข้อตกลงการใช้บริการ ดังนี้
            </div>
            <div class="text-left mt-2">
              <b>1.คำนิยาม</b>
              <br />
              &emsp;&emsp;“ผู้ใช้” หมายความว่า บุคคลหรือเจ้าของข้อมูลส่วนบุคคล
              หรือเป็นบุคคลใด ๆ ที่เกี่ยวข้องกับกิจกรรมและการดำเนินงานต่าง ๆ ที่
              มทร.ล้านนา ได้ทำการรวบรวมและประมวลผลข้อมูลส่วนบุคคล
              <br />
              &emsp;&emsp;“ข้อมูลส่วนบุคคล” หมายความว่า ข้อมูลเกี่ยวกับผู้ใช้
              ซึ่งจะทำให้สามารถระบุตัวตนของบุคคลนั้นได้
              ไม่ว่าจะทางตรงหรือทางอ้อม
              แต่ไม่รวมถึงข้อมูลของผู้ถึงแก่กรรมโดยเฉพาะตามกฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคล
              <br />
              &emsp;&emsp;“ผู้ควบคุมข้อมูลส่วนบุคคล” หมายความว่า
              บุคคลหรือนิติบุคคลซึ่งมีอำนาจหน้าที่ตัดสินใจเกี่ยวกับการเก็บรวบรวม
              ใช้หรือเปิดเผยข้อมูลส่วนบุคคล
              <br />
              &emsp;&emsp;“กฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคล” หมายความว่า
              พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562
              และกฎหมายที่เกี่ยวข้อง
              อีกทั้งให้หมายความรวมถึงกฎหมายฉบับแก้ไขเพิ่มในอนาคต
              <br />
              &emsp;&emsp;“การประมวลผล” หมายความว่า การดำเนินการใด ๆ
              กับข้อมูลส่วนบุคคลไม่ว่าจะด้วยวิธีการอัตโนมัติหรือไม่ก็ตาม เช่น
              การบันทึก การวิเคราะห์ การตั้งค่า การประเมิน การตรวจสอบมาตรฐาน
              การปรับเปลี่ยนหรือการดัดแปลง การเรียกคืน การใช้ การเปิดเผย
              (โดยการส่ง โอน
              การเผยแพร่หรือการทำให้สามารถเข้าถึงหรือพร้อมใช้งานโดยวิธีใด ๆ)
              การจัดเรียง การนำมารวมกัน การลบหรือการทำลาย เป็นต้น
            </div>
            <div class="text-left mt-2">
              <b>2.การเก็บรวบรวมข้อมูลส่วนบุคคล</b>
              <br />
              &emsp;&emsp;2.1 ข้อมูลส่วนบุคคลที่ มทร.ล้านนา
              เก็บรวบรวมภายใต้คำประกาศเกี่ยวกับความเป็นส่วนตัวนี้ ประกอบไปด้วย
              ชื่อ-นามสกุล อีเมล หมายเลขบัตรประชาชน ชื่อสถานศึกษา
              คณะที่สนใจและหลักสูตรที่มีความสนใจ
              <br />
              &emsp;&emsp;2.2
              ในการเก็บรวบรวมนั้นจะทำเพียงเท่าที่จำเป็นแก่การดำเนินงานภายใต้วัตถุประสงค์ของ
              มทร.ล้านนา เท่านั้น โดยจะดำเนินการให้เจ้าของข้อมูล รับรู้
              ให้ความยินยอมทางอิเล็กทรอนิกส์ หรือตามแบบวิธีการของ มทร.ล้านนา
              กรณีที่ มทร.ล้านนา จัดเก็บข้อมูลส่วนบุคคลอ่อนไหวของเจ้าของข้อมูล
              จะขอความยินยอมจากเจ้าของข้อมูลโดยชัดแจ้งก่อนทำการเก็บรวบรวม
              เว้นแต่การเก็บข้อมูลส่วนบุคคลและข้อมูลส่วนบุคคลอ่อนไหวจะเข้าข้อยกเว้นตามที่พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล
              พ.ศ. 2562 หรือกฎหมายอื่นที่เกี่ยวข้อง
            </div>
            <div class="text-left mt-2">
              <b>3.วัตถุประสงค์ในการเก็บรวบรวม หรือใช้ข้อมูลส่วนบุคคล</b>
              <br />
              &emsp;&emsp; 3.1 มทร.ล้านนา จะทำการเก็บรวบรวมข้อมูลส่วนบุคคลโดยมี
              วัตถุประสงค์ ขอบเขต และใช้วิธีการที่ชอบด้วยกฎหมายและเป็นธรรม
              โดยในการเก็บรวบรวมนั้นจะทำเพียงเท่าที่จำเป็นแก่การดำเนินงานภายใต้
              วัตถุประสงค์ของ มทร.ล้านนา โดยคำนึงถึงการคุ้มครองข้อมูลส่วนบุคคล
              <br />
              &emsp;&emsp; 3.2
              วัตถุประสงค์ในการเก็บรวบรวมข้อมูลและใช้ข้อมูลส่วนบุคคล
              <br />
              &emsp;&emsp;&emsp;&emsp;3.2.1
              เพื่อนำข้อมูลไปปรับปรุงและพัฒนาระบบดังกล่าวให้ดียิ่งขึ้นและตรงกับความต้องการของผู้ใช้
              <br />
              &emsp;&emsp;&emsp;&emsp;3.2.2
              เพื่อนำข้อมูลการใช้งานดำเนินการประมวลผลเชิงลึก
              ในรูปแบบฐานข้อมูลขนาดใหญ่
              สำหรับใช้ในการประเมินประสิทธิภาพและประสิทธิผลของการใช้งานระบบ
              <br />
              &emsp;&emsp; 3.3 มทร.ล้านนา
              ได้เก็บรวบรวมและรับข้อมูลส่วนบุคคลของท่านผ่านช่องทางต่าง ๆ ดังนี้
              <br />
              &emsp;&emsp;&emsp;&emsp;3.3.1 ข้อมูลส่วนบุคคลที่ท่านให้ไว้กับ
              มทร.ล้านนา ท่านอาจให้ข้อมูลส่วนบุคคลแก่ มทร.ล้านนา โดยตรง
              กรณีนี้มักเกิดขึ้นเมื่อท่านติดต่อกับ มทร.ล้านนา เพื่อสอบถาม
              กรอกแบบฟอร์มต่าง ๆ โดยทางออนไลน์หรือโดยเอกสาร
              เพื่อสมัครใช้บริการหรือร่วมกิจกรรม สอบถามข้อมูล
              หรือให้ความเห็น/คำติชมแก่ มทร.ล้านนา เป็นต้น
              <br />
              &emsp;&emsp;&emsp;&emsp;3.3.2
              ข้อมูลส่วนบุคคลที่เก็บรวบรวมจากท่านโดยอัตโนมัติ มทร.ล้านนา
              อาจเก็บรวบรวมข้อมูลทางเทคนิคบางอย่างเกี่ยวกับอุปกรณ์
              กิจกรรมและรูปแบบการเข้าชม ข้อมูลประวัติการใช้งานเว็บไซต์
              (Browsing) ของท่านโดยอัตโนมัติโดยใช้คุกกี้ (Cookies)
              และเทคโนโลยีอื่น ๆ ที่คล้ายคลึงกัน
              รายละเอียดเพิ่มเติมโปรดดูเพิ่มเติมที่ “นโยบายการใช้คุกกี้”
              <br />
              &emsp;&emsp;&emsp;&emsp;3.3.3 ข้อมูลส่วนบุคคลที่ มทร.ล้านนา
              ได้รับมาจากบุคคลหรือหน่วยงานภายนอก มทร.ล้านนา
              อาจได้รับข้อมูลส่วนบุคคลของท่านมาจากบุคคลภายนอกเป็นครั้งคราว อาทิ
              ตัวแทน นายหน้า ผู้ให้บริการ และหน่วยงานของรัฐ
              <br />
              &emsp;&emsp;3.4 ในการเก็บรวบรวมข้อมูลส่วนบุคคลของผู้ใช้
              ผู้ใช้จะได้รับการแจ้งถึงรายละเอียดต่าง ๆ
              ตามที่ระบุในคำประกาศเกี่ยวกับความเป็นส่วนตัวนี้
              ซึ่งรวมถึงแต่ไม่จำกัดเฉพาะพื้นฐานทางกฎหมายในการเก็บรวบรวม ใช้
              และ/หรือเปิดเผยข้อมูลส่วนบุคคลภายใต้วัตถุประสงค์อันชอบด้วยกฎหมาย
              หรือหากเป็นกรณีที่กฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคลกำหนดให้ต้องได้รับความยินยอมจากผู้ใช้
              มทร.ล้านนา
              จะขอความยินยอมโดยชัดแจ้งจากผู้ใช้เพื่อให้สามารถประมวลผลข้อมูลส่วนบุคคลของผู้ใช้ได้
              <br />
              &emsp;&emsp;3.5
              ข้อมูลที่ได้จากผู้ใช้จะถูกนำไปประมวลผลและแสดงผลตามวัตถุประสงค์ของการ
              และจะทำการเปิดเผยตามวัตถุประสงค์ที่แจ้งไว้
            </div>
            <div class="text-left mt-2">
              <b>4. การเปิดเผยข้อมูลส่วนบุคคล</b>
              <br />
              &emsp;&emsp; 4.1 ข้อมูลส่วนบุคคลที่ได้รับ มทร.ล้านนา
              จะเก็บรวบรวมข้อมูลต่อเมื่อได้รับความยินยอมจากท่านตามที่กฎหมายกำหนด
              เว้นแต่มีความจำเป็นตามกรณีที่กฎหมายอนุญาต
              <br />
              &emsp;&emsp;&emsp;&emsp;4.1.1 ข้อมูลส่วนบุคคลของท่านที่ มทร.ล้านนา
              ดำเนินเก็บรวบรวม ใช้ และ/หรือเปิดเผย เช่น ข้อมูลส่วนตัว เช่น
              ชื่อ-นามสกุล อีเมล หมายเลขบัตรประชาชน
              <br />
              &emsp;&emsp;&emsp;&emsp;4.1.2 ข้อมูลเพื่อการประมวลผล ชื่อสถานศึกษา
              คณะที่สนใจและหลักสูตรที่มีความสนใจ ข้อมูลการเข้าใช้งานระบบ
              <br />
              &emsp;&emsp;&emsp;&emsp;4.1.3 ข้อมูลอื่น ๆ เช่น การใช้งานระบบ
              เสียง ภาพนิ่ง ภาพเคลื่อนไหว
              และข้อมูลอื่นใดที่ถือว่าเป็นข้อมูลส่วนบุคคลภายใต้กฎหมายคุ้มครองข้อมูลส่วนบุคคล
              <br />
              &emsp;&emsp; 4.2 ข้อมูลส่วนบุคคลที่มีความอ่อนไหว (Sensitive Data)
              คือ ข้อมูลส่วนบุคคลที่กฎหมายกำหนดเป็นการเฉพาะซึ่ง มทร.ล้านนา
              จะเก็บรวบรวม ใช้
              และ/หรือเปิดเผยข้อมูลส่วนบุคคลที่มีความอ่อนไหวต่อเมื่อได้รับความยินยอมโดยชัดแจ้งจากท่าน
              หรือในกรณีที่มีความจำเป็นตามกรณีที่กฎหมายอนุญาต
              เพื่อวัตถุประสงค์ในการพิสูจน์และยืนยันตัวตนของผู้ใช้บริการที่ขอสมัคร
              และ/หรือทำธุรกรรมผ่านช่องทางดิจิทัล เว็บไซต์ หรือช่องทางอื่นใด
              เป็นต้น
              <br />
              &emsp;&emsp; 4.3 ข้อมูลด้านเทคนิค อาทิ
              ข้อมูลการเข้าใช้งานเว็บไซต์และระบบต่าง ๆ ของ มทร.ล้านนา
              ข้อมูลจราจรทางคอมพิวเตอร์ (Log)
              ข้อมูลการติดต่อและสื่อสารระหว่างท่านและผู้ใช้งานรายอื่น
              ข้อมูลจากการบันทึกการใช้งาน เช่น ตัวระบุอุปกรณ์ หมายเลข IP
              ของคอมพิวเตอร์ รหัสประจำตัวอุปกรณ์ ประเภทอุปกรณ์
              ข้อมูลเครือข่ายมือถือ ข้อมูลการเชื่อมต่อ
              ข้อมูลตำแหน่งที่ตั้งทางภูมิศาสตร์ ประเภทของเบราว์เซอร์ (Browser)
              ข้อมูลบันทึกการเข้าออกระบบ
              ข้อมูลแอปพลิเคชันหรือเว็บไซต์ที่ท่านเข้าถึงก่อนและหลัง (Referring
              Website) ข้อมูลบันทึกประวัติการใช้ระบบ ข้อมูลบันทึกการเข้าสู่ระบบ
              (Login Log) พฤติกรรมการใช้งาน (Customer Behavior) สถิติการเข้าระบบ
              เวลาที่เยี่ยมชมระบบ (Access Time) ข้อมูลที่ท่านค้นหา
              การใช้ฟังก์ชันต่าง ๆ ในระบบ และข้อมูลที่ได้เก็บรวบรวมผ่านคุกกี้
              (Cookies) หรือเทคโนโลยีอื่นที่คล้ายกัน
            </div>
            <div class="text-left mt-2">
              <b>5. แนวทางในการดำเนินการคุ้มครองข้อมูลส่วนบุคคล</b>
              <br />
              &emsp;&emsp;มทร.ล้านนา จะจัดเก็บข้อมูลส่วนบุคคลเท่าที่จำเป็น
              โดยคำนึงถึงวัตถุประสงค์และความจำเป็น ทั้งนี้ มทร.ล้านนา
              จะเก็บรักษาข้อมูลส่วนบุคคลของท่านไว้เป็นอย่างดีตามมาตรการป้องกันด้านการบริหารจัดการ
              (administrative safeguard) มาตรการป้องกันด้านเทคนิค (technical
              safeguard) และมาตรการป้องกันทางกายภาพ (physical safeguard)
              เพื่อรักษาความมั่นคงปลอดภัยในการประมวลผลข้อมูลส่วนบุคคลที่เหมาะสม
              หมายความว่า มีการธำรงไว้ซึ่งความลับ (confidentiality)
              ความถูกต้องครบถ้วน (integrity)
              และให้ข้อมูลอยู่ในลักษณะที่พร้อมใช้งาน (availability)
              และเพื่อป้องกันการละเมิดข้อมูลส่วนบุคคล โดยได้กำหนดนโยบาย ระเบียบ
              และหลักเกณฑ์ในการคุ้มครองข้อมูลส่วนบุคคล เช่น
              มาตรฐานความปลอดภัยของระบบเทคโนโลยีสารสนเทศ
              และมาตรการเพื่อป้องกันไม่ให้ผู้รับข้อมูลไปจาก มทร.ล้านนา
              ใช้หรือเปิดเผยข้อมูลนอกวัตถุประสงค์ หรือโดยไม่มีอำนาจหรือโดยไม่ชอบ
              และ มทร.ล้านนา ได้มีการปรับปรุงนโยบาย ระเบียบ
              และหลักเกณฑ์ดังกล่าวเป็นระยะ ๆ ตามความจำเป็นและเหมาะสม
              <br />
              &emsp;&emsp;โดยสิทธิของท่านในข้อนี้เป็นสิทธิตามกฎหมายที่ท่านควรทราบ
              โดยท่านสามารถขอใช้สิทธิต่าง ๆ ได้ภายใต้ข้อกำหนดของกฎหมาย
              และนโยบายที่กำหนดไว้ในขณะนี้หรือที่จะมีการแก้ไขเพิ่มเติมในอนาคต
              ตลอดจนหลักเกณฑ์ตามที่ มทร.ล้านนา กำหนดขึ้น
              และในกรณีท่านมีอายุไม่ครบ 20 ปีบริบูรณ์
              หรือถูกจำกัดความสามารถในการทำนิติกรรมตามกฎหมาย
              ท่านสามารถขอใช้สิทธิโดยให้บิดาและมารดา ผู้ใช้อำนาจปกครอง
              หรือมีผู้อำนาจกระทำการแทนเป็นผู้แจ้งความประสงค์
            </div>
            <div class="text-left mt-2">
              <b>6. สิทธิในการเข้าถึง</b>
              <br />
              &emsp;&emsp;มทร.ล้านนา
              ขอสงวนสิทธิในการปรับปรุงหรือแก้ไขช่องทางการให้บริการหรือเนื้อหาใด
              ๆ บนเว็บไซต์นี้ ในเวลาใด ๆ นอกจากนี้
              มทร.ล้านนาสงวนสิทธิที่จะปฏิเสธหรือจำกัดการเข้าถึงเว็บไซต์นี้ของบุคคลใด
              หรือจากเลขที่อยู่อินเตอร์เน็ต (IP Address) ใด
              โดยไม่จำเป็นต้องบอกกล่าวหรือระบุเหตุผลในการดำเนินการนั้น
            </div>
            <div class="text-left mt-2">
              <b>7. การทบทวนและเปลี่ยนแปลงนโยบายการคุ้มครองข้อมูลส่วนบุคคล</b>
              <br />
              &emsp;&emsp; มทร.ล้านนา
              อาจทำการปรับปรุงหรือแก้ไขนโยบายนี้เป็นครั้งคราวเพื่อให้สอดคล้องกับข้อกำหนดตามกฎหมาย
              การเปลี่ยนแปลงการดำเนินงานของ มทร.ล้านนา
              รวมถึงข้อเสนอแนะและความคิดเห็นจากหน่วยงานต่าง ๆ
              โดยจะทำการประกาศแจ้งการเปลี่ยนแปลงให้ทราบอย่างชัดเจน
              ก่อนจะเริ่มดำเนินการเปลี่ยนแปลงใด ๆ
            </div>
            <div class="modal-footer d-flex justify-content-center align-items-center pb-5 pt-3">
              <button
                type="button"
                class="btn btn-primary"
                @click="setIsConsent"
              >
                <i class="ti ti-check"></i>
                &nbsp;ยอมรับเงื่อนไข
              </button>
              <button
                type="button"
                id="closeModal"
                style="display: none;"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- model consent -->
  </div>
</template>

<script>
import HeaderView from './layouts/HeaderView.vue'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import Swal from 'sweetalert2'
import api from '../assets/services'
import $ from 'jquery'

export default {
  components: {
    HeaderView,
    VueBootstrapTypeahead,
  },
  data () {
    return {
      school_lists: [],
      citizen_id: '',
      fullname: '',
      tel: '',
      email: '',
      school: '',
      facId: 0,
      isConsent: 0,
      fac_list: [
        { id: 1, name: 'คณะบริหารธุรกิจและศิลปศาสตร์' },
        { id: 2, name: 'คณะวิทยาศาสตร์และเทคโนโลยีการเกษตร' },
        { id: 3, name: 'คณะวิศวกรรมศาสตร์' },
        { id: 4, name: 'คณะศิลปกรรมและสถาปัตยกรรมศาสตร์' },
        { id: 5, name: 'วิทยาลัยเทคโนโลยีและสหวิทยาการ' },
      ],
      depName: '',
    }
  },
  methods: {
    setIsConsent () {
      $('#closeModal').click()
      this.isConsent = 1
    },
    validateForm () {
      if (this.isConsent !== 1) {
        $('#consentRule').click()
      } else if (this.school === '') {
        Swal.fire({
          title: 'ตรวจสอบ',
          text: 'กรุณากรอกชื่อโรงเรียนปัจจุบัน/school',
          icon: 'warning',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: 'ตกลง',
          denyButtonText: 'ยกเลิก',
        }).then((result) => {
          console.log('กรุณากรอกชื่อโรงเรียนปัจจุบัน/school')
        })
      } else {
        const $myForm = $('#formprofile')
        if (!$myForm[0].checkValidity()) {
          $('#formprofile').addClass('was-validated')
        } else {
          $('#formprofile').removeClass('was-validated')
          this.register()
        }
      }
    },
    register () {
      this.$store.state.isLoading = true
      api.registerUser(
        this.$store.state.URL,
        {
          citizenId: this.citizen_id,
          fullname: this.fullname,
          tel: this.tel,
          email: this.email,
          school: this.school,
          facId: this.facId,
          isConsent: this.isConsent,
          depName: this.depName,
        },
        this.header,
        (result) => {
          if (result.status === 'SUCCESS') {
            localStorage.token = result.data.accessToken
            setTimeout(() => {
              this.OAuth(this.citizen_id)
              this.$router.push('/activity').catch(() => { })
              this.$store.state.isLoading = false
            }, 1000)
          } else if (result.status === 'ALREADY_IN_USE') {
            this.$store.state.isLoading = false
            this.$router.push('/activity').catch(() => { })
          } else {
            this.$store.state.isLoading = false
            if (this.school === '') {
              Swal.fire({
                title: 'ตรวจสอบ',
                text: 'กรุณากรอกชื่อโรงเรียนปัจจุบัน/school',
                icon: 'warning',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: 'ตกลง',
                denyButtonText: 'ยกเลิก',
              }).then((result) => {
                console.log(result)
              })
            }
            // Swal.fire({
            //   title: 'ตรวจสอบ',
            //   text: result.message,
            //   icon: 'warning',
            //   showDenyButton: false,
            //   showCancelButton: false,
            //   confirmButtonText: 'เข้าสู่ระบบใหม่',
            //   denyButtonText: 'ยกเลิก',
            // }).then((result) => {
            //   localStorage.clear()
            //   this.$router.push('/').catch(() => {})
            // })
          }
        },
        (_error) => {
          this.$store.state.isLoading = false
          // localStorage.clear()
          // this.$router.push('/').catch(() => {})
        },
      )
    },
    CheckUser (citizenId) {
      this.$store.state.isLoading = true
      api.OAuthCheck(
        this.$store.state.URL,
        { citizenId: citizenId },
        this.header,
        (result) => {
          if (result.status === 'SUCCESS') {
            this.$store.state.isLoading = false
            localStorage.token = result.data.accessToken
            this.OAuth(citizenId)
            this.$router.push('/activity').catch(() => { })
          } else if (result.status === 'NOT_REGISTER') {
            // this.$router.push({ name: 'Regis', params: { id: citizenId } }).catch(() => { })
            this.$store.state.isLoading = false
          } else {
            this.$store.state.isLoading = false
            Swal.fire({
              title: 'ตรวจสอบ',
              text: result.message,
              icon: 'warning',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'เข้าสู่ระบบใหม่',
              denyButtonText: 'ยกเลิก',
            }).then((result) => {
              localStorage.clear()
              this.$router.push('/').catch(() => { })
            })
          }
        },
        (_error) => {
          this.$store.state.isLoading = false
          localStorage.clear()
          this.$router.push('/').catch(() => { })
        },
      )
    },
    getSchools () {
      this.$store.state.isLoading = true
      api.schoolData(
        this.$store.state.URL,
        this.header,
        (result) => {
          if (result.status === 'SUCCESS') {
            this.$store.state.isLoading = false
            this.school_lists = []
            result.data.forEach((v) => {
              this.school_lists.push(v['school_name'])
            })
          } else {
            this.$store.state.isLoading = false
            Swal.fire({
              title: 'ตรวจสอบ',
              text: result.message,
              icon: 'warning',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'เข้าสู่ระบบใหม่',
              denyButtonText: 'ยกเลิก',
            }).then((result) => {
              localStorage.clear()
              this.$router.push('/').catch(() => { })
            })
          }
        },
        (_error) => {
          this.$store.state.isLoading = false
          localStorage.clear()
          this.$router.push('/').catch(() => { })
        },
      )
    },
  },
  mounted () {
    if (this.$route.params.id) {
      this.citizen_id = this.$route.params.id
      if (this.citizen_id.length === 9 || this.citizen_id.length === 13) {
        this.CheckUser(this.citizen_id)
        this.getSchools()
        $('#consentRule').click()
      } else {
        localStorage.clear()
        this.$router.push('/').catch(() => { })
      }
    } else {
      this.$router.push('/').catch(() => { })
    }
  },
}
</script>

<style>
.vbt-autcomplete-list[data-v-9a21a6f4] {
  background-color: #ffffff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Regis.vue